import layout1 from './layout1/Layout1Config';
import layout2 from './layout2/Layout2Config';

const FuseLayoutConfigs = {
  layout1,
  layout2,
};

export default FuseLayoutConfigs;
